// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2vteY","unreadBadge":"styles_unreadBadge__lFjtu","modalContent":"styles_modalContent__1uD_6","modal":"styles_modal__FT4wZ"};